import { Box, withStyles } from '@material-ui/core';
import FsHeaderMedium from 'ui-elements/typography/FsHeaderMedium';
import { spaceBetweenBoxProps } from 'globals/utils';

export const HeadlineWrapper = withStyles(({ spacing }) => ({
  root: {
    ...spaceBetweenBoxProps,
    marginBottom: spacing(2),
  },
}))(Box);

export const Headline = withStyles(({ spacing }) => ({
  root: {
    marginLeft: spacing(1),
  },
}))(FsHeaderMedium);
